module.exports = __webpack_public_path__ + "img/icon-ui-library.13544d4b.svg";